/* eslint-disable no-restricted-globals */
/* eslint-disable no-unused-expressions */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from "react";
import { observer } from "mobx-react";
import Toaster, { toasterState } from "Components/common/toaster";
import { makeApi, URLS } from "Utils/apiURL";
import userDetail from "Stores/userDetail";
import { alertStore } from "Components/common/AlertBox";

const GoogleOAuthForSignIn = observer(() => {
  const getAuthCode = () => {
    try {
      const url = new URL(window.location.href);
      const code = url?.searchParams.get("code");
      !code
        ? url?.href?.indexOf("access_denied") !== -1
          ? closeWindow()
          : ""
        : "";
      return code;
    } catch (e) {
      closeWindow();
      return null;
    }
  };

  const getAuthState = () => {
    try {
      const url = new URL(window.location.href);
      const state = url?.searchParams.get("state");
      return state;
    } catch (e) {
      closeWindow();
      return null;
    }
  };

  const handleGoogleOAuth = async () => {
    const code = getAuthCode();
    const state = getAuthState();
    if (code) {
      const response = await makeApi({
        url: URLS.signInWithGoogle,
        method: "POST",
        data: {
          authToken: code,
          source: state,
          redirectUrl: `/signupSuccess?redirect=${state}`
        }
      });
      let error = "";

      switch (response?.data?.toString()) {
        case "true":
          error = "";
          break;
        case "business":
          error = "Please enter a valid work email address";
          break;
        case "disposable":
        case "false":
          error = "Please enter a valid email address";
          break;
        default:
          error = "Something went wrong";
          break;
      }

      if (error === "") {
        if (state.toLowerCase() === "plugin") {
          window.opener.postMessage(
            {
              type: "PLUGIN_SOURCE_SIGNUP",
              redirectionUrl: `/pluginSuccess?type=signin`
            },
            "*"
          );
          closeWindow();
        } else if (state.toLowerCase() === "seo") {
          window.opener.postMessage({ type: "GOOGLE_AUTH_SUCCESS" }, "*");
          closeWindow();
        } else if (state.toLowerCase() === "web") {
          try {
            // 1. Try standard postMessage (for popups)
            if (window.opener) {
              window.opener.postMessage({ type: "WEB_GOAUTH_ACCESS" }, "*");
            }

            // 2. Try BroadcastChannel (fallback for when opener is null/iframe)
            if (typeof BroadcastChannel !== "undefined") {
              const bc = new BroadcastChannel("google_auth");
              bc.postMessage({ type: "WEB_GOAUTH_ACCESS" });
              bc.close();
            }
          } catch (e) {
            console.error("OAuth Communication Error", e);
          }
          // Force closure with a small delay for the message to propagate
          setTimeout(() => {
            window.close();
            self.close();
          }, 100);
        }
      } else {
        setTimeout(() => {
          window.opener.postMessage(
            {
              type: "GOOGLE_OUTH_ERR",
              message: error,
              msgType: "error",
              popupState: true
            },
            "*"
          );
          closeWindow();
        }, 3000);
      }
    }
  };

  const closeWindow = () => {
    window?.close();
  };

  useEffect(() => {
    handleGoogleOAuth();
  }, []);

  return (
    <div className="pageClass">
      <Toaster />
      <div className="pageCont">
        <div className="connectAppSection">
          <div>
            <div>Please wait while we sign you in</div>
            <div style={{ marginTop: "10px" }}> Signing in... </div>
          </div>
        </div>
      </div>
    </div>
  );
});

export default GoogleOAuthForSignIn;
